/* tslint:disable */
/* eslint-disable */
export enum AuditHistoryEnum {
  Serviceaftale = 'Serviceaftale',
  Serviceordre = 'Serviceordre',
  Serviceabonnement = 'Serviceabonnement',
  Henviser = 'Henviser',
  Installatoer = 'Installatoer',
  Fabrikat = 'Fabrikat',
  Partner = 'Partner',
  Tilvalg = 'Tilvalg',
  Varenr = 'Varenr',
  AreaBlacklist = 'AreaBlacklist',
  Model = 'Model',
  Rabatkampagne = 'Rabatkampagne',
  Postnummer = 'Postnummer',
  Partnerabonnement = 'Partnerabonnement'
}
